import React, { useMemo } from 'react'
import { motion } from 'framer-motion'
import { createColumnHelper } from '@tanstack/react-table'
import { ActionDelete, Table } from '@demandlocal/components'
import { useGetPaginatedVinSolutionsDealerships } from '../../../../api/admin/useGetPaginatedVinSolutionsDealerships'
import { Link } from 'react-router-dom'
import toast from 'react-hot-toast'
import { useRemoveVinSolutionsDealershipConnection } from '../../../../api/admin/partners/useRemoveVinSolutionsDealershipConnection'
import { queryClient } from '../../../../api/queryClient'

type VinSolutionsCol = {
  DealerId: number
  Name: string
  City: string
  State: string
  mappedEntry?: {
    label: string
    value: number
  }
}

const columnHelper = createColumnHelper<VinSolutionsCol>()

export default function VinSolutions(): JSX.Element {
  const { mutateAsync: removeVinSolutionsDealershipConnection } =
    useRemoveVinSolutionsDealershipConnection()
  const columns = useMemo(
    () => [
      columnHelper.accessor('DealerId', {
        header: () => 'ID',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.accessor('Name', {
        header: () => 'Dealership',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.display({
        id: 'mapped',
        header: () => 'Mapped To',
        cell: ({ row }) => {
          if (row.original.mappedEntry) {
            return (
              <Link
                to={`../../../dealerships/${row.original.mappedEntry.value}/edit`}
                className="text-primary-persian-blue font-bold">
                {row.original.mappedEntry.label}
              </Link>
            )
          }
        },
      }),
      columnHelper.accessor('City', {
        header: () => 'City',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.accessor('State', {
        header: () => 'State',
        cell: (info) => info.getValue(),
        enableSorting: false,
      }),
      columnHelper.display({
        id: 'actions',
        header: () => 'Actions',
        cell: (info) => (
          <div className={'flex flex-row'}>
            <ActionDelete
              // @ts-expect-error TS(2339) FIXME: Property 'className' does not exist on type 'IntrinsicAttributes... Remove this comment to see the full error message
              className={
                'cursor-pointer fill-primary-persian-blue stroke-primary-persian-blue'
              }
              onClick={async () => {
                if (confirm('Are you sure you want to remove this connection? ')) {
                  const toastId = toast.loading('Removing connection...')
                  await removeVinSolutionsDealershipConnection({
                    dealership_id: info.row.original.DealerId,
                  })
                  await queryClient.invalidateQueries([
                    'admin',
                    'partners',
                    'vinsolutions',
                  ])
                  toast.success('Dealership deleted successfully', { id: toastId })
                }
              }}
            />
          </div>
        ),
      }),
    ],
    [removeVinSolutionsDealershipConnection],
  )

  return (
    <motion.div className="flex flex-col gap-2 pt-5">
      <Table
        columns={columns}
        filters={{}}
        fetchFn={useGetPaginatedVinSolutionsDealerships}
      />
    </motion.div>
  )
}
